import { Component, Input } from '@angular/core';
import {
  RolloverShareholderOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-shareholder.options';
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';
import {
  WarningArrayItemDeletionComponent,
} from '../../../../warning-array-item-deletion/warning-array-item-deletion.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";


@Component({
  selector: 'app-rollover-share-holders-form',
  templateUrl: './rollover-share-holders-form.component.html',
  styleUrls: ['./rollover-share-holders-form.component.scss'],
  standalone: false,
})
export class RolloverShareHoldersFormComponent {

  @Input()
  form: AdvancedForm<RolloverOptions>;

  constructor(public modalService: NgbModal) {

  }

  get shareholders(): AdvancedFormArray<RolloverShareholderOptions> {
    return this.form.formElements.shareholders as AdvancedFormArray<RolloverShareholderOptions>;
  }

  getTitle(shareholder: AdvancedFormGroup<RolloverShareholderOptions>): AdvancedFormControl<string, string, string> {
    return shareholder.formElements.title as AdvancedFormControl<string, string, string>;
  }

  isSeller(shareholder: AdvancedFormGroup<RolloverShareholderOptions>): AdvancedFormControl<boolean, boolean, boolean> {
    return shareholder.formElements.isSeller as AdvancedFormControl<boolean, boolean, boolean>;
  }

  addShareholder() {
    this.shareholders.appendNew();
  }

  async removeShareholder(shareHolderIndexToRemove: number) {
    const modal = this.modalService.open(WarningArrayItemDeletionComponent);
    (modal.componentInstance as WarningArrayItemDeletionComponent).objectDefinition = 'cet actionnaire';
    modal.closed.subscribe(async result => {
      if (result === true) {
        this.shareholders.delete(shareHolderIndexToRemove);

        return;
      }
    });

    return;
  }

}
